import { Component } from '@angular/core';

export interface FeatureItem {
  readonly iconPath: string;
  readonly title: string;
  readonly description: string;
}

@Component({
  selector: 'app-static-text',
  standalone: true,
  imports: [],
  templateUrl: './static-text.html',
  styleUrl: './static-text.scss',
})
export class StaticText {
  readonly badgeIconPath = '/icons/doctor-2.svg';
  readonly staticImagePath = '/images/static-image.svg';

  readonly features: readonly FeatureItem[] = [
    {
      iconPath: '/icons/shield-2.svg',
      title: 'Governed asset discovery',
      description:
        'Explore datasets, models and concepts through a structured healthcare-first experience.',
    },
    {
      iconPath: '/icons/heart.svg',
      title: 'Trusted institutional workflows',
      description:
        'Support secure access patterns, permissions and collaboration across organisations.',
    },
    {
      iconPath: '/icons/face.svg',
      title: 'AI and analytics readiness',
      description:
        'Connect reusable healthcare models and use cases with real-world innovation needs.',
    },
    {
      iconPath: '/icons/doctor-2.svg',
      title: 'Ecosystem collaboration',
      description:
        'Enable providers, public health teams and researchers to work from a shared platform.',
    },
  ];
}
